import { Link } from 'react-router-dom';
import apiClient from '../../services/apiClient';

export default function BillingCancel() {
  const retryCheckout = async () => {
    try {
      const res = await apiClient.post(`/billing/checkout`);
      window.location.href = res.data.url;
    } catch (error) {
      console.error('Checkout failed:', error);
    }
  };

  return (
    <div className="container text-center mt-5">
      <h2>Payment Canceled</h2>
      <p>You can try again anytime.</p>

      <button className="btn btn-primary mt-3 me-2" onClick={retryCheckout}>
        Try Again
      </button>
      <Link to="/dashboard" className="btn btn-outline-secondary mt-3">
        Go to Dashboard
      </Link>
    </div>
  );
}
